import { requestService } from 'shared/utils/services/requestService';
import { bugsnag } from 'shared/utils/services/bugsnag';

export default function assignClient(clientId: string) {
  try {
    return requestService({
      url: `/web-api/darwin/assign?clientId=${clientId}`,
      method: 'GET',
    });
  } catch (error) {
    bugsnag(error);
    return null;
  }
}
